import { connect } from 'react-redux'
import { EventTab } from '../components'

const mapStateToProps = (state, ownProps) => {
  return ({
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EventTab)


// WEBPACK FOOTER //
// ./src/Pages/User/containers/EventTab.js